// extracted by mini-css-extract-plugin
module.exports = {"menuInner":"FacetMenu_menuInner__2uo7G","icon":"FacetMenu_icon__1fFNx"};